/**
 * AppLayout Component - Layout
 * Main application layout: sidebar + header + content area
 * Uses Tailwind for layout styling
 */

import { Outlet } from 'react-router-dom';
import { useTheme } from '@/hooks/useTheme';
import { useAppStore } from '@/stores/app.store';
import { useAudience } from '@/hooks/useAudience';
import { FIADOSA_SIDEBAR, UNE_CREDITO_SIDEBAR } from '@/constants';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';

export function AppLayout() {
  useTheme(); // sync theme state to DOM
  const sidebarOpen = useAppStore((s) => s.sidebarOpen);
  // Audiencia derivada del rol RBAC (une_fiadosa → Fiado SA) + override del switcher.
  const { resolvedRole } = useAudience();
  const sidebarSections = resolvedRole === 'BACKOFFICE' ? FIADOSA_SIDEBAR : UNE_CREDITO_SIDEBAR;

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <Sidebar sections={sidebarSections} isOpen={sidebarOpen} />

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 lg:hidden"
          onClick={() => useAppStore.getState().setSidebarOpen(false)}
        />
      )}

      {/* Main area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
